module.exports = __webpack_public_path__ + "static/media/checkmark-circle-outline-green.f8bb7de9.svg";